import React, { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { IWrapperProps } from 'utils';
import { appLanguageVar } from '../graphql/cache';

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill');
  require('@formatjs/intl-pluralrules/locale-data/de'); // Add locale data for de
}

const nlMsg = require('./messages/nl.json');
const enMsg = require('./messages/en.json');
const frMsg = require('./messages/fr.json');

const loadedMessages = {
  nl: nlMsg,
  en: enMsg,
  fr: frMsg,
};

interface ITranslateIntlProviderProps extends IWrapperProps {
  userLocale?: string;
}

const TranslateIntlProvider: React.FC<ITranslateIntlProviderProps> = ({ children, userLocale }) => {
  const language = useReactiveVar(appLanguageVar);

  useEffect(() => {
    if (!language && userLocale) {
      // Get locale from user or default to 'nl'
      const locale = userLocale?.split('-')[0] || 'nl';
      appLanguageVar(locale);
    }
  }, [userLocale]);

  const currentLanguage = (language || 'nl') as keyof typeof loadedMessages;
  const messages = loadedMessages[currentLanguage];

  return (
    <IntlProvider
      onError={() => {
        return null;
      }}
      messages={messages}
      locale={currentLanguage}
      defaultLocale="nl"
    >
      {children}
    </IntlProvider>
  );
};

export default TranslateIntlProvider;
